import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalSearchClienteProps } from '@modules/viagem/interfaces/SearchClienteModal'
import TableCliente from '../Table'
import Button from '@components/Common/Button'

const ModalCliente: React.FC <ModalSearchClienteProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar cliente"
            width = "100%"
        >
            <TableCliente {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalCliente